import React from "react";
import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import Role from "enums/Role";
import { PANE_BORDER, PANE_PADDING_X, rowGapSx } from "./paneLayout";

// Platform and owner roles are not cardholders, so they never carry a policy.
// Computed once: it used to be rebuilt inside the map, for every row.
const POLICY_ROLES = Object.values(Role).filter(
  (role) =>
    role !== Role.SuperAdmin &&
    role !== Role.Owner &&
    role !== Role.PlatformOwner &&
    role !== Role.PlatformAdmin,
);

interface RolePaneProps {
  selectedRole: string;
  onSelectRole: (role: string) => void;
}

const RolePane: React.FC<RolePaneProps> = ({ selectedRole, onSelectRole }) => {
  const { t } = useTranslation();

  return (
    <List sx={{ padding: PANE_PADDING_X, borderRight: PANE_BORDER }}>
      {POLICY_ROLES.map((role, index) => (
        <ListItem
          disablePadding
          key={role}
          sx={rowGapSx(index, POLICY_ROLES.length)}
        >
          <ListItemButton
            selected={selectedRole === role}
            onClick={() => onSelectRole(role)}
          >
            <ListItemText primary={t(role)} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default RolePane;
